import {useEffect, useRef} from "react";

const useOutsideClick = (callback, shouldPreventDefault) => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (shouldPreventDefault) {
          event.preventDefault();
        }
        callback();
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref, shouldPreventDefault]);

  return ref;
};

export default useOutsideClick;